import { MemberCardDisplayMode } from './MemberCardDisplayMode'

class FirebaseMemberEditor {
  
  constructor(firebase, member, currentMember, teamId) {
    this.firebase = firebase
    this.member = member
    this.currentMember = currentMember
    this.teamId = teamId
  }

  getMember() {
    return this.member
  }

  getDisplayMode() {
    return MemberCardDisplayMode.Edit
  }

  allowPhoneNumberEdits() {
    return false
  }

  showSettings() {
    return this.member.access !== 'invitee'
  }
  
  /**
   * Only admins can edit other members info in the team
   */
  disableEdits() {
    return !(this.member.userId === this.currentMember.userId
      || this.currentMember.access === 'admin')
  }

  disableAdminSwitch() {
    return this.currentMember.access !== 'admin'
  }

  /**
   * TODO: Save the displayName inside the team only and propagate to the rooms inside the team only
   */
  updateMemberField(name, value) {
    this.member[name] = value
    // displayName updated in user's metadata.
    // metadata values are propagated to the user's teams, team's users and rooms
    if (name === 'displayName') {
      this.firebase.database()
        .ref(`users/${this.member.userId}/metadata/${name}`)
        .set(value)
    }
    // Update the member setting in the team's members and user's teams sections
    const updates = {}
    updates[`teams/${this.teamId}/members/${this.member.userId}/${name}`] = value
    updates[`users/${this.member.userId}/teams/${this.teamId}/${name}`] = value
    this.firebase.database().ref().update(updates)
  }

  /**
   * Does nothing, as edits are real time updates in the database
   */
  completeAction() {}

  validate() {
    return { success: true }
  }

  /**
   * TODO. Cancel action on edit mode is mapped to member removal 
   */
  cancelAction() {}
  
  showActionCompleteButton() {
    return true
  }

  /**
   * Do not show cancel when editing a member profile as it's a no-op.
   */
  showActionCancelButton() {
    return false
  }

}

export default FirebaseMemberEditor


// WEBPACK FOOTER //
// ./src/infra/FirebaseMemberEditor.js